import { Button, Form, Modal } from 'antd';
import { useIntl } from 'react-intl';
import { useDefaultFormErrorNotification, useWindowSize } from '@/hooks';
import { ModalProps } from '@/types/ModalProps';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import { CreatePartVehicleApplicationFreeFormValues } from '@/core/domain/operational/PartVehicleApplications/PartVehicleApplications.types';
import PartApplicationFreeModalForm from './PartApplicationFreeModalForm';

interface Props extends ModalProps {
  onClose: () => void;
  onOk: (values: CreatePartVehicleApplicationFreeFormValues) => void;
  isLoading: boolean;
}

const PartApplicationFreeCreateModal: React.FC<Props> = ({
  visible,
  handleVisible,
  onOk,
  isLoading,
}) => {
  const intl = useIntl();
  const [form] = Form.useForm();
  const { sendFormErrorNotification } = useDefaultFormErrorNotification();
  const { isMobile } = useWindowSize();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();

      await onOk(values);

      form.resetFields();
    } catch (err) {
      sendFormErrorNotification(err);
    }
  };

  const handleCancel = () => {
    form.resetFields();

    handleVisible();
  };

  return (
    <Modal
      title={'Aplicação da peça - Livre'}
      open={visible}
      onCancel={handleCancel}
      confirmLoading={isLoading}
      width={620}
      destroyOnClose
      footer={[
        <SpaceForButton flexDirection={isMobile ? 'column' : 'row-reverse'}>
          <Button block type="primary" onClick={handleOk} loading={isLoading}>
            {intl.formatMessage({ id: 'commons.modal.button.save' })}
          </Button>
          <Button block type="primary" ghost onClick={handleCancel}>
            {intl.formatMessage({ id: 'commons.modal.button.cancel' })}
          </Button>
        </SpaceForButton>,
      ]}
    >
      <PartApplicationFreeModalForm form={form} />
    </Modal>
  );
};

export default PartApplicationFreeCreateModal;
